import React from "react";
import AutoAwesomeMotionRoundedIcon from "@mui/icons-material/AutoAwesomeMotionRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Draggable } from "react-beautiful-dnd";

function RemoveFromPlaylist({ onClick, program }) {
  return (
    <button
      className="btn--text-primary"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(program);
        return true;
      }}
    >
      <CancelRoundedIcon />
    </button>
  );
}

export default function DraggableSeriesItem({
  series,
  getEpisodesForSeries,
  actions,
  controlComponent,
  draggableId,
  index,
  removeProgram = null,
  editingDisabled = false,
}) {
  function removeProgramWrapper(...params) {
    if (removeProgram) {
      removeProgram(...params);
    }
  }

  return (
    <Draggable key={series.series_guid} draggableId={draggableId} index={index} isDragDisabled={editingDisabled}>
      {(provided) => (
        <li
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            ...provided.draggableProps.style,
          }}
          className="content-list__item content-list__item--clickable"
          onClick={() => getEpisodesForSeries({ value: series.series_guid, label: series.series_name })}
          key={`content-list__item__${index}`}
        >
          <span className="content-item">
            {typeof controlComponent === "function" ? controlComponent() : null}
            {!editingDisabled ? (
              <span className="content-item__control">
                <MenuRoundedIcon />
              </span>
            ) : null}
            <span className="content-item__description">
              <span className="content-item__heading">{series.formatted_name || series.series_name}</span>
              <span className="content-item__provider">
                <span className="content-item__provider__inner">{series.title.provider.provider_name}</span>
              </span>
              <span className="content-item__sub-heading">
                <span>Total Seasons: {series?.seasons.length}</span>
              </span>
              <br />
            </span>
            <span className="content-item__actions">
              {actions.map((action, key) => (
                <span className="content-item__action" key={key}>
                  {action}
                </span>
              ))}
              <span className="content-item__action">
                <button
                  className="btn--text-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    getEpisodesForSeries({
                      value: series.series_guid,
                      label: series.formatted_name || series.series_name,
                    });
                  }}
                >
                  <AutoAwesomeMotionRoundedIcon />
                </button>
              </span>
              {removeProgram && !editingDisabled ? (
                <span className={`content-item__action`}>
                  <RemoveFromPlaylist onClick={removeProgramWrapper} program={series} />
                </span>
              ) : null}
            </span>
          </span>
        </li>
      )}
    </Draggable>
  );
}
